import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import OptionValueMapping from './OptionValueMapping';
import ClientProvider from './client';
export default createDemo(import.meta.url, OptionValueMapping, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/autocomplete/demos/option-value-mapping/OptionValueMapping.tsx",
    "fileName": "OptionValueMapping.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport TextField from '@mui/material/TextField';\nimport Autocomplete from '@mui/material/Autocomplete';\n\ninterface Film {\n  id: number;\n  label: string;\n}\n\nconst films: Film[] = [\n  { id: 1, label: 'The Shawshank Redemption' },\n  { id: 2, label: 'The Godfather' },\n  { id: 3, label: 'The Dark Knight' },\n];\n\nfunction getFilmValue(film: Film) {\n  return film.id;\n}\n\nexport default function OptionValueMapping() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [value, setValue] = React.useState<number | null>(2);\n\n  return (\n    <div>\n      <div>{`value: ${value ?? 'null'}`}</div>\n      <br />\n      <Autocomplete\n        options={films}\n        getOptionLabel={(option) => option.label}\n        getOptionValue={getFilmValue}\n        value={value}\n        onChange={(_event, newValue) => {\n          setValue(newValue);\n        }}\n        sx={{ width: 300 }}\n        renderInput={(params) => <TextField {...params} label=\"Film\" />}\n      />\n    </div>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 40,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport TextField from '@mui/material/TextField';\nimport Autocomplete from '@mui/material/Autocomplete';\n\ninterface Film {\n  id: number;\n  label: string;\n}\n\nconst films: Film[] = [\n  { id: 1, label: 'The Shawshank Redemption' },\n  { id: 2, label: 'The Godfather' },\n  { id: 3, label: 'The Dark Knight' },\n];\n\nfunction getFilmValue(film: Film) {\n  return film.id;\n}\n\nexport default function OptionValueMapping() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [value, setValue] = React.useState<number | null>(2);\n\n  return (\n    <div>\n      <div>{`value: ${value ?? 'null'}`}</div>\n      <br />\n      <Autocomplete\n        options={films}\n        getOptionLabel={(option) => option.label}\n        getOptionValue={getFilmValue}\n        value={value}\n        onChange={(_event, newValue) => {\n          setValue(newValue);\n        }}\n        sx={{ width: 300 }}\n        renderInput={(params) => <TextField {...params} label=\"Film\" />}\n      />\n    </div>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 40,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/TextField",
      "@mui/material/Autocomplete"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
